export var MONTH_NAMES = ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"];
export var WEEKDAY_NAMES = ["ПН", "ВТ", "СР", "ЧТ", "ПН", "СБ", "НД"];